import React, { FC, useEffect, useState } from "react";
import "./instant-discounts-request.scss";
import { useNavigate, useParams } from "react-router";
import { useAppSelector, useAppDispatch } from "../../app/hooks";
import { fetchInstantDiscountRequestStatus, fetchInstantDiscountRequests, DiscountRequestsEditActions } from "../../reducers/discountEditSlice";
import { isUserLoggedIn } from "../../reducers/authSlice";
import { DateTime } from "luxon";
import { convertTime24to12 } from "../../utils/common";
import { useTranslation } from "react-i18next";
import i18n from "../../i18n";
import { useTranslationContext } from "../../context/locale.context";

const InstantDiscountsRequest: FC = () => {
  const { clubId }: any = useParams();
  const isUser = useAppSelector(isUserLoggedIn);
  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const discountRequests: Array<any> = useAppSelector(fetchInstantDiscountRequests);
  const discountProcessStatus: any = useAppSelector(fetchInstantDiscountRequestStatus);
   const { locale, setLocale } = useTranslationContext();
  

  const handleStatus = async (status: string, id: string) => {
    let payload = { status, id }
    dispatch(DiscountRequestsEditActions.processInstantDiscountRequest(payload))
  };

  const getTimeFormat = (time: string) => {
    let splitTimeString = time.split(":")
    let convertedString = convertTime24to12(splitTimeString[0], splitTimeString[1])
    return convertedString
  }


  useEffect(() => {
    dispatch(DiscountRequestsEditActions.resetInstantDiscountPage())
  }, [])

  useEffect(() => {
    const payload = { clubId }
    dispatch(DiscountRequestsEditActions.getInstantDiscountRequest(payload));
  }, [discountProcessStatus]);

  const sourceToDashboard = () => {
    navigate("/dashboard");
  }

  const sourceToContact = () => {
    window.open("https://www.integolf.com/contact", "_blank")
  }

  const updateLocale = (locale: string) => {
    setLocale(locale);
    i18n.changeLanguage(locale);
    document.cookie = `INTEGOLF_COURSES_PORTAL_LOCALE=${locale};`
  }
  
  const login = () => {
    navigate("/");
  };

  const { t } = useTranslation("")

  return (
    <div className="discountUpdateWrapper">
      <header className="">
        <div className="container">
          <div className="d-flex align-items-center justify-content-between">
            <a href="void:0">
              <img
                src={`${process.env.PUBLIC_URL}/assets/images/brand/integolf-black.svg`}
                alt="integolf"
                className="img-fluid"
              />
            </a>
            <div className="d-flex align-items-end justify-content-end">
            {!isUser ? (
              <div className="login-wrapper">
                <button
                  className="button button-primary button-rounded button-sm fontsize-14"
                  onClick={login}
                >
                  {t("InstantDiscountRequestPage.LoginPage")}
                </button>
              </div>
            ) : <div className="login-wrapper cursor-pointer dashboard-wrapper" onClick={() => sourceToDashboard()}>{t("InstantDiscountRequestPage.GoToDashboard")}</div>}
            <div className="select-language-dropdown"
              style={{ width: "52px",marginLeft:"10px",height:"41px" }}
            >
              <select
                id="languages"
                value={locale ? locale : "en"}
                className="form-select bg-transparent text-dark fw-medium border-1 p-2"
                onChange={(e) => updateLocale(e.target.value)}
              >
                <option value="en">EN</option>
                <option value="fr">FR</option>
              </select>
            </div>
            </div>
          </div>
        </div>
      </header>

      <section className="discountHeroWrapper">
        <div className="container">
          <div className="_heroContent">
            <h4 className="mb-3">{t("InstantDiscountRequestPage.title")}</h4>
            {(!discountRequests?.length) ? <h1 className="mb-3">{t("InstantDiscountRequestPage.expiredMessage")}</h1> : <> <h1 className="mb-3">
              {t("InstantDiscountRequestPage.attentionMessage")}
            </h1></>}
          </div>

          <div className="discounUpdateContent">
            {discountRequests?.length > 0 && <h5 className="text-center mb-4 pb-2">{t("InstantDiscountRequestPage.InstantDiscount")}</h5>}
            {discountRequests?.length > 0 && discountRequests?.map((discount: any) => (
              <div className="_box mb-3">
                <div className="row">
                  <div className="col">
                    <div className="row">
                      <div className="col-3 col-sm-6">
                        <label className="mb-1 mb-md-2">{t("InstantDiscountRequestPage.TableHeading.DiscountGiven")}</label>
                        <h6><span>{discount.discount}%</span>
                        </h6>
                      </div>
                      <div className="col-3 col-sm-6">
                        <label className="mb-1 mb-md-2">{t("InstantDiscountRequestPage.TableHeading.StartTime")}</label>
                        <h6><span>{discount?.startTime ? getTimeFormat(discount?.startTime) : "n/a"}</span>
                        </h6>
                      </div>
                      <div className="col-3 col-sm-6">
                        <label className="mb-1 mb-md-2">{t("InstantDiscountRequestPage.TableHeading.EndTime")}</label>
                        <h6><span>{discount?.endTime ? getTimeFormat(discount?.endTime) : "n/a"}</span>
                        </h6>
                      </div>
                      <div className="col-3 col-sm-6">
                        <label className="mb-1 mb-md-2">{t("InstantDiscountRequestPage.TableHeading.TeeSheetsSold")}</label>
                        <h6><span>{discount?.teesheetSold ? discount?.teesheetSold : "n/a"}</span>
                        </h6>
                      </div>
                      <div className="col-3 col-sm-6 mt-2 mt-sm-0">
                        <label className="mb-1 mb-md-2">{t("InstantDiscountRequestPage.TableHeading.Date")}</label>
                        <h6><span>{DateTime.fromFormat(discount.date, "yyyy-MM-dd").toFormat("EEE, dd LLL")}</span>
                        </h6>
                      </div>
                    </div>
                  </div>
                  <div className="col-auto d-flex align-items-center justify-content-center">
                    {(discount?.status == "pending") &&
                      <div>
                        <button
                          onClick={() => handleStatus("accepted", discount?._id)}
                          disabled={(["accepted", "rejected"].includes(discount?.status))}
                          type="button"
                          className="button button-primary button-rounded fw800 me-2">
                          {t("InstantDiscountRequestPage.Approve")}
                        </button>
                        <button
                          disabled={(["accepted", "rejected"].includes(discount?.status))}
                          type="button"
                          onClick={() => handleStatus("rejected", discount?._id)}
                          className="button button-danger button-rounded fw800">
                          {t("InstantDiscountRequestPage.Reject")}
                        </button>
                      </div>
                    }
                    {(discount?.status == "accepted") && <span className="styled-span">{t("InstantDiscountRequestPage.Approved")}</span>}
                    {(discount?.status == "rejected") && <span className="styled-span-reject">{t("InstantDiscountRequestPage.Rejected")}</span>}
                  </div>
                </div>
              </div>
            ))}
          </div>

          <div className="_sections">
            <div className="_sections_box">
              <div className="_sections_box_content">
                <img
                  src={`${process.env.PUBLIC_URL}/assets/images/icons/clock_circle.svg`}
                  alt=""
                  className="img-fluid mx-auto mb-3"
                />
                <h5>{t("InstantDiscountRequestPage.WhyText")}</h5>
                <p>
                  {t("InstantDiscountRequestPage.WhyDescription")}
                </p>
              </div>
            </div>
            <div className="_sections_box">
              <div className="_sections_box_content">
                <img
                  src={`${process.env.PUBLIC_URL}/assets/images/icons/question_circle.svg`}
                  alt=""
                  className="img-fluid mx-auto mb-3"
                />
                <h5>{t("InstantDiscountRequestPage.ReviewDeadline")}</h5>
                <p>
                  {t("InstantDiscountRequestPage.ReviewDescription")}
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="helpSection">
        <span className="imgTopRight">
          <img
            src={`${process.env.PUBLIC_URL}/assets/images/help_bg.png`}
            alt=""
            className="img-fluid"
          />
        </span>
        <span className="imgBottomLeft">
          <img
            src={`${process.env.PUBLIC_URL}/assets/images/help_bg.png`}
            alt=""
            className="img-fluid"
          />
        </span>
        <div className="container">
          <div className="row">
            <div className="col-12">
              <div className="_content text-center">
                <img
                  src={`${process.env.PUBLIC_URL}/assets/images/icons/gear.svg`}
                  alt=""
                  className="img-fluid mx-auto mb-3"
                />
                <h2 className="mb-3">{t("InstantDiscountRequestPage.NeedHelp")}</h2>
                <p>
                  {t("InstantDiscountRequestPage.NeedSupportContact")}{" "}
                  <a href="mailto:support@integolf.com" className="text-white">
                    support@integolf.com
                  </a>
                </p>

                <button
                  type="button" onClick={() => sourceToContact()}
                  className="button button-primary button-rounded fw700 mt-3"
                >
                  {t("InstantDiscountRequestPage.ContactUs")}
                </button>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default InstantDiscountsRequest;
